import { useEffect } from 'react';
import { getUploadUrl } from '@/config/api';

/**
 * Hook to preload images for better performance
 * Preloads images from the next section/slide to reduce loading time
 */
export const useImagePreloader = (imageUrls: string[]) => {
    useEffect(() => {
        if (!imageUrls || imageUrls.length === 0) return;

        const links: HTMLLinkElement[] = [];

        imageUrls.forEach((url) => {
            if (!url) return;

            // Create preload link element
            const link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'image';
            link.href = getUploadUrl(url);

            // Add to document head
            document.head.appendChild(link);
            links.push(link);
        });

        // Cleanup on unmount
        return () => {
            links.forEach((link) => {
                if (link.parentNode) {
                    link.parentNode.removeChild(link);
                }
            });
        };
    }, [imageUrls]);
};

/**
 * Utility function to extract image URLs from slides
 */
export const extractImageUrls = (slides: any[]): string[] => {
    const urls: string[] = [];

    slides.forEach((slide) => {
        if (slide?.media?.url && slide.media_type === 'image') {
            urls.push(slide.media.url);
        }
        if (slide?.background_media?.url) {
            urls.push(slide.background_media.url);
        }
        if (slide?.left_media?.url) {
            urls.push(slide.left_media.url);
        }
        if (slide?.right_media?.url) {
            urls.push(slide.right_media.url);
        }
    });

    return urls;
};
